"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as c } from "react";
import t from "../components/Icon/SvgIcon.js";
const e = (l) => /* @__PURE__ */ o(
  t,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...l,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18.778 9.966c0 1.382-.416 2.712-1.23 3.899l-5.265 6.997c-.125.14-.289.268-.502.025l-5.22-6.925-.057-.098A6.83 6.83 0 0 1 5.25 9.969c.017-3.706 3.056-6.719 6.773-6.719 3.725 0 6.755 3.012 6.755 6.716M12.023 22.25c.438 0 .87-.199 1.159-.521l5.422-7.205a7.96 7.96 0 0 0 1.424-4.558C20.028 5.573 16.437 2 12.023 2 7.62 2 4.02 5.572 4 9.973c.021 1.685.534 3.281 1.435 4.533l.003.005c.03.059.082.161.132.206l5.25 6.964c.3.362.739.569 1.203.569m-2.5-12.49a2.51 2.51 0 0 1 2.5-2.513c1.38 0 2.5 1.116 2.5 2.488a2.51 2.51 0 0 1-2.5 2.513 2.497 2.497 0 0 1-2.5-2.488m-1.25 0a3.75 3.75 0 0 0 3.75 3.738 3.76 3.76 0 0 0 3.75-3.763 3.75 3.75 0 0 0-3.75-3.738 3.76 3.76 0 0 0-3.75 3.763",
        clipRule: "evenodd"
      }
    )
  }
), r = c(e);
export {
  r as Location,
  r as default
};
